import * as z from "zod";
import { requiredString } from "components/form/utils";

export const jobTitleSchema = z.object({
  name: requiredString(),
});
